import r, { forwardRef as ae, useState as Q, useEffect as le } from "react";
import { PasswordInput as se, NumberInput as de, InputBase as ce, useProps as ue, useCombobox as me, CloseButton as pe, Combobox as M, Box as ge, ScrollArea as fe, Tooltip as be } from "@mantine/core";
import { t as R } from "./vanilla-BMQk9Zav.mjs";
import { a as P, T as A, c as ee } from "./createReactComponent-mYmqlnjV.mjs";
import { t as U } from "i18next";
import x from "clsx";
import { Select as w, InputLabel as te, Text as Y, Input as K, Box as H, InputDescription as re, PhoneNumberInput as he } from "@huspy/briks-web";
import { m as Se } from "./css-DAV6FxX7.mjs";
import { shadows as ke, spacingPrimitives as ve, fontWeightPrimitives as ye, fontSizePrimitives as we, colorPrimitives as Ce } from "@huspy/briks-core";
import { ChevronDown as Ee } from "@huspy/briks-icons";
function Be(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (typeof a != "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function xe(e) {
  var t = Be(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function Ie(e, t, n) {
  return t = xe(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Z(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function X(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Z(Object(n), !0).forEach(function(a) {
      Ie(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Z(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
var _e = (e) => function() {
  for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
    n[a] = arguments[a];
  var c = Object.assign({}, ...n.map((u) => u.styles)), s = Object.keys(c), p = s.filter((u) => "mappings" in c[u]), g = (u) => {
    var f = [], S = {}, d = X({}, u), k = !1;
    for (var b of p) {
      var m = u[b];
      if (m != null) {
        var v = c[b];
        k = !0;
        for (var l of v.mappings)
          S[l] = m, d[l] == null && delete d[l];
      }
    }
    var y = k ? X(X({}, S), d) : u, W = function() {
      var o = y[h], i = c[h];
      try {
        if (i.mappings)
          return "continue";
        if (typeof o == "string" || typeof o == "number") {
          if (process.env.NODE_ENV !== "production" && !i.values[o].defaultClass)
            throw new Error();
          f.push(i.values[o].defaultClass);
        } else if (Array.isArray(o))
          for (var _ = 0; _ < o.length; _++) {
            var E = o[_];
            if (E != null) {
              var G = i.responsiveArray[_];
              if (process.env.NODE_ENV !== "production" && !i.values[E].conditions[G])
                throw new Error();
              f.push(i.values[E].conditions[G]);
            }
          }
        else
          for (var V in o) {
            var L = o[V];
            if (L != null) {
              if (process.env.NODE_ENV !== "production" && !i.values[L].conditions[V])
                throw new Error();
              f.push(i.values[L].conditions[V]);
            }
          }
      } catch (ne) {
        if (process.env.NODE_ENV !== "production") {
          class B extends Error {
            constructor(F) {
              super(F), this.name = "SprinklesError";
            }
          }
          var O = (T) => typeof T == "string" ? '"'.concat(T, '"') : T, j = (T, F, ie) => {
            throw new B('"'.concat(T, '" has no value ').concat(O(F), ". Possible values are ").concat(Object.keys(ie).map(O).join(", ")));
          };
          if (!i)
            throw new B('"'.concat(h, '" is not a valid sprinkle'));
          if ((typeof o == "string" || typeof o == "number") && (o in i.values || j(h, o, i.values), !i.values[o].defaultClass))
            throw new B('"'.concat(h, '" has no default condition. You must specify which conditions to target explicitly. Possible options are ').concat(Object.keys(i.values[o].conditions).map(O).join(", ")));
          if (typeof o == "object") {
            if (!("conditions" in i.values[Object.keys(i.values)[0]]))
              throw new B('"'.concat(h, '" is not a conditional property'));
            if (Array.isArray(o)) {
              if (!("responsiveArray" in i))
                throw new B('"'.concat(h, '" does not support responsive arrays'));
              var q = i.responsiveArray.length;
              if (q < o.length)
                throw new B('"'.concat(h, '" only supports up to ').concat(q, " breakpoints. You passed ").concat(o.length));
              for (var $ of o)
                i.values[$] || j(h, $, i.values);
            } else
              for (var N in o) {
                var z = o[N];
                if (z != null && (i.values[z] || j(h, z, i.values), !i.values[z].conditions[N]))
                  throw new B('"'.concat(h, '" has no condition named ').concat(O(N), ". Possible values are ").concat(Object.keys(i.values[z].conditions).map(O).join(", ")));
              }
          }
        }
        throw ne;
      }
    };
    for (var h in y)
      var C = W();
    return e(f.join(" "));
  };
  return Object.assign(g, {
    properties: new Set(s)
  });
}, Te = (e) => e, Re = function() {
  return _e(Te)(...arguments);
}, J = Re({ conditions: void 0, styles: { fontWeight: { values: { "fw-100": { defaultClass: "_1svxe9w0" }, "fw-200": { defaultClass: "_1svxe9w1" }, "fw-300": { defaultClass: "_1svxe9w2" }, "fw-400": { defaultClass: "_1svxe9w3" }, "fw-500": { defaultClass: "_1svxe9w4" }, "fw-600": { defaultClass: "_1svxe9w5" }, "fw-700": { defaultClass: "_1svxe9w6" }, "fw-800": { defaultClass: "_1svxe9w7" } } } } }), Pe = P({ defaultClassName: "_3a0d740", variantClassNames: { disabled: { true: "_3a0d741", false: "_3a0d742" } }, defaultVariants: {}, compoundVariants: [] }), We = "ttmgoh0", Oe = P({ defaultClassName: "_18id84m0", variantClassNames: { size: { lg: "_18id84m1", md: "_18id84m2" }, hasTrail: { true: "_18id84m3", false: "_18id84m4" }, hasHead: { true: "_18id84m5", false: "_18id84m6" } }, defaultVariants: {}, compoundVariants: [[{ hasTrail: !0, size: "md" }, "_18id84m7"], [{ hasTrail: !0, size: "lg" }, "_18id84m8"], [{ hasHead: !0, size: "md" }, "_18id84m9"], [{ hasHead: !0, size: "lg" }, "_18id84ma"]] }), ze = P({ defaultClassName: "_18id84mb", variantClassNames: { size: { lg: "_18id84mc", md: "_18id84md" } }, defaultVariants: {}, compoundVariants: [] }), Me = P({ defaultClassName: "_1j0ihqb0", variantClassNames: { size: { lg: "_1j0ihqb1", md: "_1j0ihqb2" }, hasTrail: { true: "_1j0ihqb3", false: "_1j0ihqb4" }, hasHead: { true: "_1j0ihqb5", false: "_1j0ihqb6" } }, defaultVariants: {}, compoundVariants: [[{ size: "lg", hasTrail: !0 }, "_1j0ihqb7"], [{ size: "md", hasTrail: !0 }, "_1j0ihqb8"]] }), De = "_1ihlpde0", Ae = P({ defaultClassName: "qbd1q70", variantClassNames: { size: { lg: "qbd1q71", md: "qbd1q72" } }, defaultVariants: {}, compoundVariants: [] });
const Ve = ({
  styles: e,
  classNames: t,
  disabled: n,
  size: a = "md",
  success: c,
  errorMessage: s,
  trail: p,
  type: g,
  head: u
}) => {
  const f = !!((c ?? s ?? p) || g === "password"), {
    // @ts-expect-error
    wrapper: S,
    input: d,
    error: k,
    section: b,
    root: m,
    label: v,
    description: l
  } = { ...t };
  return {
    inputClassNames: {
      ...t,
      label: x(J({ fontWeight: "fw-400" }), Pe({ disabled: n }), v),
      wrapper: x(ze({ size: a }), S),
      input: x(Oe({ size: a, hasTrail: f, hasHead: !!u }), d),
      error: x(We, J({ fontWeight: "fw-600" }), k),
      section: x(Me({ size: a, hasTrail: f }), b),
      root: x(De, m),
      description: x(Ae({ size: a }), l)
    },
    inputStyles: e
  };
}, Le = ae(function(t, n) {
  const { inputClassNames: a, inputStyles: c } = Ve(t), {
    trail: s,
    disabled: p,
    errorMessage: g,
    placeholder: u,
    head: f,
    noNumberSeparators: S,
    type: d,
    classNames: k,
    styles: b,
    ...m
  } = t, v = typeof s == "string" ? /* @__PURE__ */ r.createElement(A, { size: "sm", c: p ? "neutral.5" : "neutral.6" }, s) : s;
  return d === "password" ? (
    // @ts-ignore
    /* @__PURE__ */ r.createElement(
      se,
      {
        leftSection: f,
        disabled: p,
        classNames: a,
        styles: { ...c, visibilityToggle: { color: "black" } },
        placeholder: u,
        error: g,
        type: d,
        ref: n,
        ...m
      }
    )
  ) : d === "number" ? /* @__PURE__ */ r.createElement(
    de,
    {
      leftSection: f,
      rightSection: v,
      labelProps: { size: m.size },
      rightSectionPointerEvents: "none",
      disabled: p,
      placeholder: u,
      classNames: a,
      ...!S && {
        thousandSeparator: U("common.thousandSeparator") ?? ",",
        decimalSeparator: U("common.decimalSeparator") ?? "."
      },
      styles: c,
      error: g,
      ref: n,
      inputWrapperOrder: ["label", "input", "description", "error"],
      ...m,
      onChange: (l) => {
        var y;
        typeof l == "string" && l.length === 0 && (l = void 0), (y = m.onChange) == null || y.call(m, l);
      }
    }
  ) : /* @__PURE__ */ r.createElement(
    ce,
    {
      leftSection: f,
      rightSection: s,
      labelProps: { size: m.size },
      rightSectionPointerEvents: "none",
      disabled: p,
      placeholder: u,
      classNames: a,
      styles: c,
      error: g,
      type: d,
      ref: n,
      inputWrapperOrder: ["label", "input", "description", "error"],
      ...m,
      onChange: (l) => {
        var y;
        typeof l.target.value == "string" && l.target.value.length === 0 && (l.target.value = null), (y = m.onChange) == null || y.call(m, l);
      }
    }
  );
});
var je = ee("chevron-down", "IconChevronDown", [
  ["path", { d: "M6 9l6 6l6 -6", key: "svg-0" }]
]), Ne = ee("chevron-up", "IconChevronUp", [
  ["path", { d: "M6 15l6 -6l6 6", key: "svg-0" }]
]), Fe = P({ defaultClassName: "ovskww2 ovskww1", variantClassNames: { size: { lg: "ovskww3", md: "ovskww4" } }, defaultVariants: {}, compoundVariants: [] }), Xe = "ovskww0", Ye = "ovskww5";
function He({ label: e, description: t }) {
  return /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(A, { fz: "sm", fw: 500, m: 0 }, e), t && /* @__PURE__ */ r.createElement(A, { fz: "xs", c: "neutral.6", fw: 400, m: 0, mt: R.spacing.sm }, t));
}
const mt = (e) => {
  const {
    size: t = "md",
    data: n,
    disabled: a,
    placeholder: c,
    dropdownScroll: s = !1,
    dropdownMaxHeight: p = 340,
    allowSearch: g,
    value: u,
    isClearable: f,
    ...S
  } = ue("Select", {}, e), d = me({ onDropdownClose: () => d.resetSelectedOption() }), [k, b] = Q(""), v = n.every((o) => o.label !== k) ? n.filter((o) => o.label.toLowerCase().includes(k.toLowerCase().trim())) : n, l = n.find((o) => o.value === u);
  le(() => {
    u === null || !g || b((l == null ? void 0 : l.label) ?? "");
  }, [u]);
  const y = () => {
    d.closeDropdown(), g && b((l == null ? void 0 : l.label) || "");
  }, W = g && d.dropdownOpened ? k : l == null ? void 0 : l.label, h = t === "md" ? { height: 16, width: 16 } : { height: 20, width: 20 }, C = /* @__PURE__ */ r.createElement(r.Fragment, null, f && (l != null && l.value) ? /* @__PURE__ */ r.createElement(
    pe,
    {
      size: 20,
      onMouseDown: (o) => o.preventDefault(),
      styles: { root: { color: R.colors.neutral[8] } },
      onClick: () => e.onChange(""),
      "aria-label": "Clear value"
    }
  ) : /* @__PURE__ */ r.createElement(r.Fragment, null, d.dropdownOpened ? /* @__PURE__ */ r.createElement(Ne, { color: R.colors.neutral[8], ...h }) : /* @__PURE__ */ r.createElement(je, { ...h, color: R.colors.neutral[8] }))), I = v.length > 0 ? v.map((o, i) => /* @__PURE__ */ r.createElement(
    M.Option,
    {
      disabled: o.disabled,
      value: o.value,
      key: o.value,
      "data-test": `${S["data-test"]}-option-${i}`
    },
    /* @__PURE__ */ r.createElement(He, { ...o })
  )) : /* @__PURE__ */ r.createElement(ge, { className: Ye }, /* @__PURE__ */ r.createElement(A, { fz: "sm", fw: 500, c: "neutral.6" }, "No results"));
  return /* @__PURE__ */ r.createElement(
    M,
    {
      offset: 4,
      withinPortal: !1,
      store: d,
      __staticSelector: "Select",
      classNames: {
        dropdown: Xe,
        option: Fe({ size: "md" })
      },
      disabled: a,
      onOptionSubmit: (o) => {
        S.onChange(o), d.closeDropdown();
      }
    },
    /* @__PURE__ */ r.createElement(M.Target, null, /* @__PURE__ */ r.createElement(
      Le,
      {
        ...S,
        trail: C,
        onClick: () => d.openDropdown(),
        onFocus: () => d.openDropdown(),
        onBlur: y,
        disabled: a,
        placeholder: c,
        pointer: !0,
        size: t,
        value: W ?? "",
        ...g ? {
          contentEditable: !0,
          onChange: (o) => {
            d.updateSelectedOptionIndex(), b(o.currentTarget.value);
          }
        } : { onKeyDown: (o) => {
          o.preventDefault();
        }, contentEditable: !1 }
      }
    )),
    /* @__PURE__ */ r.createElement(M.Dropdown, { mah: p }, /* @__PURE__ */ r.createElement(M.Options, null, s ? /* @__PURE__ */ r.createElement(fe.Autosize, { mah: p, type: "always", scrollbarSize: 10, scrollbars: "y" }, I) : I))
  );
}, pt = (e) => /* @__PURE__ */ r.createElement(
  be,
  {
    withArrow: !0,
    multiline: !0,
    arrowSize: 12,
    color: "neutral.7",
    p: R.spacing.sm,
    transitionProps: { transition: "pop", duration: 300 },
    styles: {
      tooltip: {
        borderRadius: "8px",
        fontSize: R.fontSizes.xs
        // textAlign: 'center',
      }
    },
    ...e
  }
);
var Ge = "css,pos,insetX,insetY,insetEnd,end,insetStart,start,flexDir,p,pl,pr,pt,pb,py,paddingY,paddingX,px,pe,paddingEnd,ps,paddingStart,ml,mr,mt,mb,m,my,marginY,mx,marginX,me,marginEnd,ms,marginStart,ringWidth,ringColor,ring,ringOffset,w,minW,maxW,h,minH,maxH,textShadowColor,bgPosition,bgPositionX,bgPositionY,bgAttachment,bgClip,bg,bgColor,bgOrigin,bgImage,bgRepeat,bgBlendMode,bgSize,bgGradient,rounded,roundedTopLeft,roundedTopRight,roundedBottomRight,roundedBottomLeft,roundedTop,roundedRight,roundedBottom,roundedLeft,roundedStartStart,roundedStartEnd,roundedStart,roundedEndStart,roundedEndEnd,roundedEnd,borderX,borderXWidth,borderXColor,borderY,borderYWidth,borderYColor,borderStart,borderStartWidth,borderStartColor,borderEnd,borderEndWidth,borderEndColor,shadow,shadowColor,x,y,z,scrollMarginY,scrollMarginX,scrollPaddingY,scrollPaddingX,aspectRatio,boxDecorationBreak,zIndex,boxSizing,objectPosition,objectFit,overscrollBehavior,overscrollBehaviorX,overscrollBehaviorY,position,top,left,insetInline,insetBlock,inset,insetBlockEnd,insetBlockStart,insetInlineEnd,insetInlineStart,right,bottom,float,visibility,display,hideFrom,hideBelow,flexBasis,flex,flexDirection,flexGrow,flexShrink,gridTemplateColumns,gridTemplateRows,gridColumn,gridRow,gridColumnStart,gridColumnEnd,gridAutoFlow,gridAutoColumns,gridAutoRows,gap,gridGap,gridRowGap,gridColumnGap,rowGap,columnGap,justifyContent,alignContent,alignItems,alignSelf,padding,paddingLeft,paddingRight,paddingTop,paddingBottom,paddingBlock,paddingBlockEnd,paddingBlockStart,paddingInline,paddingInlineEnd,paddingInlineStart,marginLeft,marginRight,marginTop,marginBottom,margin,marginBlock,marginBlockEnd,marginBlockStart,marginInline,marginInlineEnd,marginInlineStart,spaceX,spaceY,outlineWidth,outlineColor,outline,outlineOffset,divideX,divideY,divideColor,divideStyle,width,inlineSize,minWidth,minInlineSize,maxWidth,maxInlineSize,height,blockSize,minHeight,minBlockSize,maxHeight,maxBlockSize,color,fontFamily,fontSize,fontWeight,fontSmoothing,fontVariantNumeric,letterSpacing,lineHeight,textAlign,textDecoration,textDecorationColor,textEmphasisColor,textDecorationStyle,textDecorationThickness,textUnderlineOffset,textTransform,textIndent,textShadow,textOverflow,verticalAlign,wordBreak,textWrap,truncate,lineClamp,listStyleType,listStylePosition,listStyleImage,backgroundPosition,backgroundPositionX,backgroundPositionY,backgroundAttachment,backgroundClip,background,backgroundColor,backgroundOrigin,backgroundImage,backgroundRepeat,backgroundBlendMode,backgroundSize,backgroundGradient,textGradient,gradientFromPosition,gradientToPosition,gradientFrom,gradientTo,gradientVia,gradientViaPosition,borderRadius,borderTopLeftRadius,borderTopRightRadius,borderBottomRightRadius,borderBottomLeftRadius,borderTopRadius,borderRightRadius,borderBottomRadius,borderLeftRadius,borderStartStartRadius,borderStartEndRadius,borderStartRadius,borderEndStartRadius,borderEndEndRadius,borderEndRadius,border,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,borderColor,borderInline,borderInlineWidth,borderInlineColor,borderBlock,borderBlockWidth,borderBlockColor,borderLeft,borderLeftColor,borderInlineStart,borderInlineStartWidth,borderInlineStartColor,borderRight,borderRightColor,borderInlineEnd,borderInlineEndWidth,borderInlineEndColor,borderTop,borderTopColor,borderBottom,borderBottomColor,borderBlockEnd,borderBlockEndColor,borderBlockStart,borderBlockStartColor,opacity,boxShadow,boxShadowColor,mixBlendMode,filter,brightness,contrast,grayscale,hueRotate,invert,saturate,sepia,dropShadow,blur,backdropFilter,backdropBlur,backdropBrightness,backdropContrast,backdropGrayscale,backdropHueRotate,backdropInvert,backdropOpacity,backdropSaturate,backdropSepia,borderCollapse,borderSpacing,borderSpacingX,borderSpacingY,tableLayout,transitionTimingFunction,transitionDelay,transitionDuration,transitionProperty,transition,animation,animationName,animationTimingFunction,animationDuration,animationDelay,transformOrigin,rotate,rotateX,rotateY,rotateZ,scale,scaleX,scaleY,translate,translateX,translateY,translateZ,accentColor,caretColor,scrollBehavior,scrollbar,scrollMargin,scrollMarginLeft,scrollMarginRight,scrollMarginTop,scrollMarginBottom,scrollMarginBlock,scrollMarginBlockEnd,scrollMarginBlockStart,scrollMarginInline,scrollMarginInlineEnd,scrollMarginInlineStart,scrollPadding,scrollPaddingBlock,scrollPaddingBlockStart,scrollPaddingBlockEnd,scrollPaddingInline,scrollPaddingInlineEnd,scrollPaddingInlineStart,scrollPaddingLeft,scrollPaddingRight,scrollPaddingTop,scrollPaddingBottom,scrollSnapAlign,scrollSnapStop,scrollSnapType,scrollSnapStrictness,scrollSnapMargin,scrollSnapMarginTop,scrollSnapMarginBottom,scrollSnapMarginLeft,scrollSnapMarginRight,touchAction,userSelect,fill,stroke,strokeWidth,srOnly,debug,appearance,backfaceVisibility,clipPath,hyphens,mask,maskImage,maskSize,textSizeAdjust,container,containerName,containerType,colorPalette,_light,_dark,_hover,_focus,_focusWithin,_focusVisible,_disabled,_active,_visited,_target,_readOnly,_readWrite,_empty,_checked,_enabled,_expanded,_highlighted,_before,_after,_firstLetter,_firstLine,_marker,_selection,_file,_backdrop,_first,_last,_only,_even,_odd,_firstOfType,_lastOfType,_onlyOfType,_peerFocus,_peerHover,_peerActive,_peerFocusWithin,_peerFocusVisible,_peerDisabled,_peerChecked,_peerInvalid,_peerExpanded,_peerPlaceholderShown,_groupFocus,_groupHover,_groupActive,_groupFocusWithin,_groupFocusVisible,_groupDisabled,_groupChecked,_groupExpanded,_groupInvalid,_indeterminate,_required,_valid,_invalid,_autofill,_inRange,_outOfRange,_placeholder,_placeholderShown,_pressed,_selected,_default,_optional,_open,_closed,_fullscreen,_loading,_currentPage,_currentStep,_motionReduce,_motionSafe,_print,_landscape,_portrait,_osDark,_osLight,_highContrast,_lessContrast,_moreContrast,_ltr,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_horizontal,_vertical,_starting,_collapsed,_current,_hidden,_off,_on,_today,_underValue,sm,smOnly,smDown,md,mdOnly,mdDown,lg,lgOnly,lgDown,xl,xlOnly,xlDown,2xl,2xlOnly,2xlDown,smToMd,smToLg,smToXl,smTo2xl,mdToLg,mdToXl,mdTo2xl,lgToXl,lgTo2xl,xlTo2xl,_themeMortgage,_themeBayteca,textStyle", qe = Ge.split(","), $e = "WebkitAppearance,WebkitBorderBefore,WebkitBorderBeforeColor,WebkitBorderBeforeStyle,WebkitBorderBeforeWidth,WebkitBoxReflect,WebkitLineClamp,WebkitMask,WebkitMaskAttachment,WebkitMaskClip,WebkitMaskComposite,WebkitMaskImage,WebkitMaskOrigin,WebkitMaskPosition,WebkitMaskPositionX,WebkitMaskPositionY,WebkitMaskRepeat,WebkitMaskRepeatX,WebkitMaskRepeatY,WebkitMaskSize,WebkitOverflowScrolling,WebkitTapHighlightColor,WebkitTextFillColor,WebkitTextStroke,WebkitTextStrokeColor,WebkitTextStrokeWidth,WebkitTouchCallout,WebkitUserModify,accentColor,alignContent,alignItems,alignSelf,alignTracks,all,animation,animationComposition,animationDelay,animationDirection,animationDuration,animationFillMode,animationIterationCount,animationName,animationPlayState,animationRange,animationRangeEnd,animationRangeStart,animationTimingFunction,animationTimeline,appearance,aspectRatio,azimuth,backdropFilter,backfaceVisibility,background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundPositionX,backgroundPositionY,backgroundRepeat,backgroundSize,blockSize,border,borderBlock,borderBlockColor,borderBlockStyle,borderBlockWidth,borderBlockEnd,borderBlockEndColor,borderBlockEndStyle,borderBlockEndWidth,borderBlockStart,borderBlockStartColor,borderBlockStartStyle,borderBlockStartWidth,borderBottom,borderBottomColor,borderBottomLeftRadius,borderBottomRightRadius,borderBottomStyle,borderBottomWidth,borderCollapse,borderColor,borderEndEndRadius,borderEndStartRadius,borderImage,borderImageOutset,borderImageRepeat,borderImageSlice,borderImageSource,borderImageWidth,borderInline,borderInlineEnd,borderInlineColor,borderInlineStyle,borderInlineWidth,borderInlineEndColor,borderInlineEndStyle,borderInlineEndWidth,borderInlineStart,borderInlineStartColor,borderInlineStartStyle,borderInlineStartWidth,borderLeft,borderLeftColor,borderLeftStyle,borderLeftWidth,borderRadius,borderRight,borderRightColor,borderRightStyle,borderRightWidth,borderSpacing,borderStartEndRadius,borderStartStartRadius,borderStyle,borderTop,borderTopColor,borderTopLeftRadius,borderTopRightRadius,borderTopStyle,borderTopWidth,borderWidth,bottom,boxAlign,boxDecorationBreak,boxDirection,boxFlex,boxFlexGroup,boxLines,boxOrdinalGroup,boxOrient,boxPack,boxShadow,boxSizing,breakAfter,breakBefore,breakInside,captionSide,caret,caretColor,caretShape,clear,clip,clipPath,color,colorScheme,columnCount,columnFill,columnGap,columnRule,columnRuleColor,columnRuleStyle,columnRuleWidth,columnSpan,columnWidth,columns,contain,containIntrinsicSize,containIntrinsicBlockSize,containIntrinsicHeight,containIntrinsicInlineSize,containIntrinsicWidth,container,containerName,containerType,content,contentVisibility,counterIncrement,counterReset,counterSet,cursor,direction,display,emptyCells,filter,flex,flexBasis,flexDirection,flexFlow,flexGrow,flexShrink,flexWrap,float,font,fontFamily,fontFeatureSettings,fontKerning,fontLanguageOverride,fontOpticalSizing,fontPalette,fontVariationSettings,fontSize,fontSizeAdjust,fontSmooth,fontStretch,fontStyle,fontSynthesis,fontSynthesisPosition,fontSynthesisSmallCaps,fontSynthesisStyle,fontSynthesisWeight,fontVariant,fontVariantAlternates,fontVariantCaps,fontVariantEastAsian,fontVariantEmoji,fontVariantLigatures,fontVariantNumeric,fontVariantPosition,fontWeight,forcedColorAdjust,gap,grid,gridArea,gridAutoColumns,gridAutoFlow,gridAutoRows,gridColumn,gridColumnEnd,gridColumnGap,gridColumnStart,gridGap,gridRow,gridRowEnd,gridRowGap,gridRowStart,gridTemplate,gridTemplateAreas,gridTemplateColumns,gridTemplateRows,hangingPunctuation,height,hyphenateCharacter,hyphenateLimitChars,hyphens,imageOrientation,imageRendering,imageResolution,imeMode,initialLetter,initialLetterAlign,inlineSize,inputSecurity,inset,insetBlock,insetBlockEnd,insetBlockStart,insetInline,insetInlineEnd,insetInlineStart,isolation,justifyContent,justifyItems,justifySelf,justifyTracks,left,letterSpacing,lineBreak,lineClamp,lineHeight,lineHeightStep,listStyle,listStyleImage,listStylePosition,listStyleType,margin,marginBlock,marginBlockEnd,marginBlockStart,marginBottom,marginInline,marginInlineEnd,marginInlineStart,marginLeft,marginRight,marginTop,marginTrim,mask,maskBorder,maskBorderMode,maskBorderOutset,maskBorderRepeat,maskBorderSlice,maskBorderSource,maskBorderWidth,maskClip,maskComposite,maskImage,maskMode,maskOrigin,maskPosition,maskRepeat,maskSize,maskType,masonryAutoFlow,mathDepth,mathShift,mathStyle,maxBlockSize,maxHeight,maxInlineSize,maxLines,maxWidth,minBlockSize,minHeight,minInlineSize,minWidth,mixBlendMode,objectFit,objectPosition,offset,offsetAnchor,offsetDistance,offsetPath,offsetPosition,offsetRotate,opacity,order,orphans,outline,outlineColor,outlineOffset,outlineStyle,outlineWidth,overflow,overflowAnchor,overflowBlock,overflowClipBox,overflowClipMargin,overflowInline,overflowWrap,overflowX,overflowY,overlay,overscrollBehavior,overscrollBehaviorBlock,overscrollBehaviorInline,overscrollBehaviorX,overscrollBehaviorY,padding,paddingBlock,paddingBlockEnd,paddingBlockStart,paddingBottom,paddingInline,paddingInlineEnd,paddingInlineStart,paddingLeft,paddingRight,paddingTop,page,pageBreakAfter,pageBreakBefore,pageBreakInside,paintOrder,perspective,perspectiveOrigin,placeContent,placeItems,placeSelf,pointerEvents,position,printColorAdjust,quotes,resize,right,rotate,rowGap,rubyAlign,rubyMerge,rubyPosition,scale,scrollbarColor,scrollbarGutter,scrollbarWidth,scrollBehavior,scrollMargin,scrollMarginBlock,scrollMarginBlockStart,scrollMarginBlockEnd,scrollMarginBottom,scrollMarginInline,scrollMarginInlineStart,scrollMarginInlineEnd,scrollMarginLeft,scrollMarginRight,scrollMarginTop,scrollPadding,scrollPaddingBlock,scrollPaddingBlockStart,scrollPaddingBlockEnd,scrollPaddingBottom,scrollPaddingInline,scrollPaddingInlineStart,scrollPaddingInlineEnd,scrollPaddingLeft,scrollPaddingRight,scrollPaddingTop,scrollSnapAlign,scrollSnapCoordinate,scrollSnapDestination,scrollSnapPointsX,scrollSnapPointsY,scrollSnapStop,scrollSnapType,scrollSnapTypeX,scrollSnapTypeY,scrollTimeline,scrollTimelineAxis,scrollTimelineName,shapeImageThreshold,shapeMargin,shapeOutside,tabSize,tableLayout,textAlign,textAlignLast,textCombineUpright,textDecoration,textDecorationColor,textDecorationLine,textDecorationSkip,textDecorationSkipInk,textDecorationStyle,textDecorationThickness,textEmphasis,textEmphasisColor,textEmphasisPosition,textEmphasisStyle,textIndent,textJustify,textOrientation,textOverflow,textRendering,textShadow,textSizeAdjust,textTransform,textUnderlineOffset,textUnderlinePosition,textWrap,timelineScope,top,touchAction,transform,transformBox,transformOrigin,transformStyle,transition,transitionBehavior,transitionDelay,transitionDuration,transitionProperty,transitionTimingFunction,translate,unicodeBidi,userSelect,verticalAlign,viewTimeline,viewTimelineAxis,viewTimelineInset,viewTimelineName,viewTransitionName,visibility,whiteSpace,whiteSpaceCollapse,widows,width,willChange,wordBreak,wordSpacing,wordWrap,writingMode,zIndex,zoom,alignmentBaseline,baselineShift,clipRule,colorInterpolation,colorRendering,dominantBaseline,fill,fillOpacity,fillRule,floodColor,floodOpacity,glyphOrientationVertical,lightingColor,marker,markerEnd,markerMid,markerStart,shapeRendering,stopColor,stopOpacity,stroke,strokeDasharray,strokeDashoffset,strokeLinecap,strokeLinejoin,strokeMiterlimit,strokeOpacity,strokeWidth,textAnchor,vectorEffect", Ue = $e.split(",").concat(qe), Ke = new Map(Ue.map((e) => [e, !0])), Ze = /&|@/, gt = /* @__PURE__ */ Se((e) => Ke.has(e) || e.startsWith("--") || Ze.test(e));
const D = {
  colors: { ...Ce },
  fontSizes: { ...we },
  fontWeights: { ...ye },
  spacing: { ...ve },
  shadow: { ...ke }
}, Je = (e, t) => {
  if (e)
    return {
      border: `1px solid ${D.colors["error.800"]}`,
      backgroundColor: D.colors["error.100"]
    };
  if (t)
    return {
      color: D.colors["neutral.900"],
      backgroundColor: D.colors["neutral.50"],
      opacity: 0.4
    };
}, Qe = ({
  data: e,
  label: t,
  isRequired: n,
  placeholder: a,
  isError: c,
  ...s
}) => /* @__PURE__ */ r.createElement(
  w.Root,
  {
    ...s,
    positioning: { sameWidth: !0 },
    onValueChange: s.onValueChange,
    value: typeof s.value == "string" ? [s.value] : s.value,
    items: e,
    defaultValue: s.defaultValue
  },
  t ? /* @__PURE__ */ r.createElement(w.Label, null, /* @__PURE__ */ r.createElement(te, { isRequired: n, isError: c }, t)) : null,
  /* @__PURE__ */ r.createElement(w.Control, null, /* @__PURE__ */ r.createElement(w.Trigger, { style: Je(c, s.disabled) }, /* @__PURE__ */ r.createElement(w.ValueText, { placeholder: a }), /* @__PURE__ */ r.createElement(w.Indicator, null, /* @__PURE__ */ r.createElement(Ee, null)))),
  /* @__PURE__ */ r.createElement(w.Positioner, null, /* @__PURE__ */ r.createElement(
    w.Content,
    {
      onClick: (p) => p.stopPropagation(),
      maxH: "250",
      style: { overflow: "scroll" }
    },
    e.map((p) => /* @__PURE__ */ r.createElement(w.Item, { key: p.value, item: p.value }, /* @__PURE__ */ r.createElement(w.ItemText, null, /* @__PURE__ */ r.createElement(Y, { size: "md", color: "text-primary", weight: "regular" }, p.label)), /* @__PURE__ */ r.createElement(w.ItemIndicator, null, "✓")))
  )),
  /* @__PURE__ */ r.createElement(w.HiddenSelect, null)
);
var oe = "_19hvc8n0";
const et = ({
  form: e,
  name: t,
  label: n,
  placeholder: a,
  type: c = "text",
  trail: s,
  disabled: p = !1,
  hasCommaDelimiter: g = !0,
  isRequired: u = !0,
  ...f
}) => {
  const { error: S, onChange: d, defaultValue: k } = e.getInputProps(t), [b, m] = Q(k), v = !!S, l = S ?? "", y = () => n ? /* @__PURE__ */ r.createElement(te, { isRequired: u, isError: v }, n) : /* @__PURE__ */ r.createElement(H, { h: "22px" }), W = () => /* @__PURE__ */ r.createElement(re, { mt: "1", isError: v }, l), h = (i) => b === void 0 || b === "" || b === null ? "" : b === 0 ? 0 : i ? Number(b).toLocaleString("en-US") : Number(b), C = {
    id: t,
    name: t,
    disabled: p,
    placeholder: a ?? n,
    isError: v,
    ...f
  }, I = {
    phone: /* @__PURE__ */ r.createElement(
      he,
      {
        ...C,
        defaultCountry: "ae",
        onChange: (i) => {
          i.inputValue.length > 0 && e.clearFieldError(t), i.inputValue.length === 0 ? (d(""), m("+971")) : (d(i.phone), m(i.phone));
        },
        value: b || ""
      }
    ),
    number: /* @__PURE__ */ r.createElement(
      K,
      {
        ...C,
        type: "text",
        value: h(g),
        onChange: (i) => {
          const { value: _ } = i.target, E = _.replaceAll(/\D/g, "");
          E === "" ? (d(), m("")) : (d(Number(E)), m(Number(E)));
        },
        onWheel: (i) => i.target.blur(),
        icon: s && /* @__PURE__ */ r.createElement(Y, { size: "md", color: "neutral.400" }, s)
      }
    ),
    default: /* @__PURE__ */ r.createElement(
      K,
      {
        ...C,
        type: c,
        defaultValue: k,
        onChange: (i) => d(i.target.value),
        icon: s && /* @__PURE__ */ r.createElement(Y, { size: "md", color: "neutral.400" }, s)
      }
    )
  }, o = I[c] || I.default;
  return /* @__PURE__ */ r.createElement(H, { className: oe }, y(), o, W());
}, tt = ({
  form: e,
  name: t,
  label: n,
  data: a,
  isRequired: c = !0,
  ...s
}) => {
  var g, u;
  const { defaultValue: p } = e.getInputProps(t);
  return /* @__PURE__ */ r.createElement(H, { className: oe, id: t }, /* @__PURE__ */ r.createElement(
    Qe,
    {
      name: t,
      label: n,
      data: a,
      placeholder: n,
      onValueChange: (f) => {
        e.getInputProps(t).onChange(f.value[0]);
      },
      isError: !!((g = e.getInputProps(t)) != null && g.error),
      defaultValue: [p],
      isRequired: c,
      ...s
    }
  ), /* @__PURE__ */ r.createElement(re, { color: "error.800", mt: "1" }, ((u = e.getInputProps(t)) == null ? void 0 : u.error) ?? ""));
}, ft = r.memo(
  et,
  (e, t) => e.form.getInputProps(e.name).error === t.form.getInputProps(t.name).error && e.form.getInputProps(e.name).defaultValue === t.form.getInputProps(t.name).defaultValue && e.disabled === t.disabled
), bt = r.memo(
  tt,
  (e, t) => e.form.getInputProps(e.name).error === t.form.getInputProps(t.name).error && e.form.getInputProps(e.name).defaultValue === t.form.getInputProps(t.name).defaultValue && e.disabled === t.disabled
);
export {
  ft as F,
  Le as I,
  mt as S,
  pt as T,
  Xe as a,
  bt as b,
  Fe as d,
  gt as i
};
